import { useState } from 'react';
import { IonContent, IonPage, IonIcon, IonCard, IonCardHeader, IonCardSubtitle, IonList, IonItem, IonLabel, IonButton, IonInput, IonAlert, IonLoading, useIonViewWillLeave, useIonAlert, IonCol, IonGrid, IonImg, IonRow, IonSelect, IonSelectOption, IonCheckbox, IonSpinner, useIonViewWillEnter, IonRefresher, IonRefresherContent, IonHeader, IonToolbar, IonTitle, IonButtons } from '@ionic/react';
import { eye, copy, arrowUpCircle, add, arrowDownCircle, refresh, wallet, walletOutline, walletSharp, enter, timeOutline, camera } from 'ionicons/icons';
import {
  AccountInfo,
  Keypair,
  ParsedAccountData,
  PublicKey,
} from '@solana/web3.js';
import UserService from '../../services/user';
import './Wallet.css';
import Config from '../../config/settings';
import CopyToClipboard from 'react-copy-to-clipboard';
import QRCode from 'react-qr-code';
import Accounts from '../../config/wallets';
import { WalletService } from './Wallet.svc';
import * as bip39 from "bip39";
import { Subscription } from 'rxjs';
import { Shared } from '../../shared/shared';
import QrReader from 'react-qr-scanner';
import { AppVersion } from '@awesome-cordova-plugins/app-version';
import UpdateService from '../../services/update';
import { ParsedAccount, TokenAmount } from '../../models/parsedAccount';

const Wallet: React.FC<{  shared?: Shared, userService?: UserService, updateService?: UpdateService, isAndroidDevice: boolean }> = ({ shared, userService, updateService, isAndroidDevice }) => {

  const [email, setEmail] = useState<string>();
  const [security, setSecurity] = useState<string>();
  const [pubkey, setPubkey] = useState<string>();
  const [seedkey, setSeedkey] = useState<string>();
  const [seedkeyString, setSeedkeyString] = useState<string>('');
  const [walletBalanceSOL, setWalletBalanceSOL] = useState<string>('0.000');
  const [walletBalanceNSA, setWalletBalanceNSA] = useState<string>('0.000');
  const [walletBalanceNSAN, setWalletBalanceNSAN] = useState<string>('0.000');
  const [isDevise, setDevise] = useState<string>();
  const [webTransacions = false, setWebTransactions] = useState<boolean>(false);
  const [showAlertConnection, setShowAlertConnexion] = useState(false);
  const [needNSAaccount, setNeedNSAaccount] = useState<boolean>(true);
  const [needNSANaccount, setNeedNSANaccount] = useState<boolean>(true);
  const [showSendForm = false, setShowSendForm] = useState<boolean>(false);
  const [showInAppWallet = false, setShowInAppWallet] = useState<boolean>(false);
  const [showInAppSendForm = false, setInAppShowSendForm] = useState<boolean>(false);
  const [showDepositForm = false, setShowDepositForm] = useState<boolean>(false);
  const [showBuyForm = false, setShowBuyForm] = useState<boolean>(false);
  const [showAlertSeedKey = false, setShowAlertSeedKey] = useState<boolean>(false);
  const [isLoadingWallet = false, setIsLoadingWallet] = useState<boolean>(false);
  const [showLoadingDots = false, setShowLoadingDots] = useState<boolean>(false);
  const [isRefreshing = false, setRefreshing] = useState<boolean>(false);
  const [transferToInAppChecked, setTransferToInAppChecked] = useState(false);
  const [reduction, setReduction] = useState<string>('0');
  const [total, setTotal] = useState<number>(0.000);
  const [walletContent, setWalletContent] = useState<WalletContent[]>([]);
  const [inAppWalletContent, setInAppWalletContent] = useState<WalletContent[]>([]);
  const [amount, setAmount] = useState<string>('0');
  const [transactionAddress, setTransactionAddress] = useState<string>('');
  const [transactionAmount, setTransactionAmount] = useState<string>('0');
  const [priorityFee, setPriorityFee] = useState<number>(0.000025);
  const [preSaleStatus, setPreSaleStatus] = useState<string>('Closed');
  const [sendTransactionBtnDisabled = false, setSendTransactionBtnDisabled] = useState<boolean>(false);
  const [minSolToBuy, setSolLimit] = useState<number>(0);
  const [presentAlert] = useIonAlert();
  const [isOpenQRScan, setOpenQrScan] = useState<boolean>(false);
  const [inAppCurrency, setInAppCurrency] = useState<string>('nsa');
  const [showUpdateDownload, setShowUpdateDownload] = useState<boolean>(false);
  const [showDownload, setShowDownload] = useState<boolean>(false);

  const decimals = 1000000000;
  const startPrice = 0.015727272;
  const solMint = 'So11111111111111111111111111111111111111112';
  const walletService: WalletService = new WalletService();
  const baseUrl = (Config.debugMode === false) ? Config.url : Config.urlDebug;

  let userServiceSubscribe: Subscription;

  useIonViewWillEnter(async () => {

    // On affiche le wallet mainnet par défaut
    showHideWallet(false);

    userServiceSubscribe = userService.storageInitSubject.subscribe(async (result) => {
      if (result === true) {
        // recupération des données
        setPubkey(userService.pubkey);
        setSeedkey(userService.seedkey);
        setEmail(userService.email);
        setSecurity(userService.security);

        if (webTransacions === false) {  
          setWebTransactions(true);

          if (userService.walletContentCalled === true) {
            setWalletContent(userService.getWalletContentData());
          } else {
            refreshWallet();
          }
        }

        // Check and update
        if (await AppVersion?.getVersionNumber().then(() => true).catch(() => false)) {
          setShowUpdateDownload(await updateService.checkUpdate(userService).then(res => res));
        }
        //test
        setShowUpdateDownload(await updateService.checkUpdate(userService).then(res => res));
      }
    });
    // setPreSaleStatus('Wait opening');
    setPreSaleStatus('Open');
    setReduction('15');
    //setPreSaleStatus('Closed');
  })

  useIonViewWillLeave(() => {
    if (userServiceSubscribe) {
      userServiceSubscribe.unsubscribe();
    }
  })

  function handleScan(data){
    if (data !== null && data.text) {
      setTransactionAddress(data.text);
      setOpenQrScan(false);
    }
  }

  /**
   * Explorer une adresse
   */
  function exploreAddress(address?: string) {
    if (pubkey) {
      window.open(`https://explorer.solana.com/address/${(address) ? address : userService.pubkey}?cluster=mainnet`);
    } else {
      presentAlert({
        header: 'Message',
        subHeader: '',
        message: 'You have to create a wallet on Solana Mainnet.',
        buttons: ['OK'],
      });
    }
  }

  /**
   * Afficher la box send
   */
  function showSend() {
    if (pubkey) {
      setShowBuyForm(false);
      setShowDepositForm(false);
      // setShowLabelForm(false);
      setInAppShowSendForm(false);
      if (showSendForm === false) {
        setShowSendForm(true);
      } else {
        setShowSendForm(false);
      }
    } else {
      presentAlert({
        header: 'Message',
        subHeader: '',
        message: 'You have to create a wallet on Solana Mainnet.',
        buttons: ['OK'],
      });
    }
  }

  function showInAppSend() {
    if (showInAppSendForm === true) {
      setInAppShowSendForm(false);
    } else {
      setInAppShowSendForm(true);
    }
  }

  /**
   * Afficher la box deposit
   */
  function showDeposit() {
    if (pubkey) {
      setShowBuyForm(false);
      setShowSendForm(false);
      // setShowLabelForm(false);
      setInAppShowSendForm(false);
      if (showDepositForm === false) {
        setShowDepositForm(true);
      } else {
        setShowDepositForm(false);
      }
    } else {
      presentAlert({
        header: 'Message',
        subHeader: '',
        message: 'You have to create a wallet on Solana Mainnet.',
        buttons: ['OK'],
      });
    }
  }

  /**
   * Afficher la box Join pre-sale
   */
  function showBuy() {
    if (pubkey) {
      if (showBuyForm === false) {
        setShowBuyForm(true);
      } else {
        setShowBuyForm(false);
      }
      setShowSendForm(false);
      // setShowLabelForm(false);
      setShowDepositForm(false);
      setInAppShowSendForm(false);

      updatePresaleData();
    } else {
      presentAlert({
        header: 'Message',
        subHeader: '',
        message: 'You have to create a wallet on Solana Mainnet by pressing the "Create" button.',
        buttons: ['OK'],
      });
    }
  }

  /**
   * Flouter les données du wallet
   */
  function hideValue() {
    const deviseValues = document.getElementsByClassName('devise-value');

    if (deviseValues && deviseValues.length > 0) {
      for (let index = 0; index < deviseValues.length; index++) {
        const element = deviseValues[index];
        if (element?.classList.contains('compteur-hidden')) {
          element?.classList.remove('compteur-hidden');
        } else {
          element?.classList.add('compteur-hidden');
        }
      }
    }
      
  }

  /**
   * Récupération de la balance du wallet Solana
   */
  async function getSolanaBalance() {

    if (userService && userService.pubkey) {

      return walletService
        .getSolanaBalance(
          userService
        ).then(
          async (res) => {
  
            const resultat = await res.json();
            
            let balance = (resultat?.result?.value) ? resultat?.result?.value : 0;
            
            // Parser la balance en valeur réelle
            return await traitementBalance(balance);
          }
        ).catch((_e: any) => {
          setIsLoadingWallet(false);
          const formatError = _e.toString().indexOf('NetworkError') > -1
            ? 'Impossible to access network, please check your internet access and restart the app or click on refresh button.' 
            : (!userService?.pubkey) ? 'Wallet not found, please click on CREATE button.' : 'Unable to access server'; //_e;

          presentAlert({
            header: 'Message',
            subHeader: '',
            message: 'Error ' + formatError,
            buttons: ['OK'],
          });
        });
    }

    return null;
  }

  /**
   * Récupération des compte du wallet In-App
   */
  function getInAppAccounts() {

    // Récupération contenu in-app wallet
    const url = baseUrl + 'get-inapp-wallet?email=' + userService.email + '&security=' + userService.security + '&v=' + Config.version;

    fetch(url, { signal: AbortSignal.timeout(5000) }).then(
      async (res) => {
        const result = await res.json();

        if (result && result.msg.toString().indexOf('wallet') > 0) {
          
          // Si pas de wallet trouvé, creation wallet puis rappel de la méthode
          const url = baseUrl + 'create-inapp-wallet?email=' + userService.email + '&security=' + userService.security + '&v=' + Config.version;
          
          fetch(url, { signal: AbortSignal.timeout(5000) }).then(
            async (res) => {
              await res.json();

              setTimeout(() => {
                getInAppAccounts();
              }, 1500);
            }
          );

        } else {
          setInAppWalletContent([]);

          const itemNSA: WalletContent = {
            name: 'Nebula Stars Anthill',
            symbol: 'NSA',
            mint: Config.tokenNsaAddress,
            value: result.msg.nsa,
            price: null,
            price_last: null,
            link: ``,
            img: arrowUpCircle,
            parsed: true,
          };
      
          setInAppWalletContent(walletContent => [...walletContent, itemNSA]);
      
          const itemNSAN: WalletContent = {
            name: 'Nebula Stars Anthill Nucleus',
            symbol: 'NSAN',
            mint: Config.tokenNsanAddress,
            value: result.msg.nsan,
            price: null,
            price_last: null,
            link: ``,
            img: arrowUpCircle,
            parsed: true,
          };
      
          setInAppWalletContent(walletContent => [...walletContent, itemNSAN]);
        }
      }
    ).catch(() => {
      setShowAlertConnexion(true);
    });
  }

  /**
   * Mise à jour des données de balance du wallet
   * @param balance 
   */
  async function traitementBalance(balance: number) {
    const balanceString: string = (balance / decimals).toString();

    setWalletBalanceSOL(balanceString);
    
    return await walletService.getTokenInfoPyth(solMint, userService).then(async res => {

      const response = await res.json();

      // Ajout à la liste des crypto dispo dans le wallet
      const solToken: WalletContent = {
        name: 'Solana',
        symbol: 'SOL',
        mint: solMint,
        value: balanceString.toString(),
        price: response.usdPrice,
        price_last: response.usdPrice,
        link: `https://explorer.solana.com/address/${pubkey}?cluster=mainnet`,
        img: getDeviseIcon('SOL'),
        parsed: true,
      };
  
      setWalletContent(walletContent => [...walletContent, solToken])

      return solToken;
    });
    
  }

  /**
   * Création du wallet in-app
   * @param email 
   * @param security 
   */
  function createWallet(email: any, security: any) {
    const baseUrl = (Config.debugMode === false) ? Config.url : Config.urlDebug;
    const url = baseUrl + 'create-wallet?email=' + userService.email + '&security=' + userService.security + '&v=' + Config.version;
  
    fetch(url, { signal: AbortSignal.timeout(5000) }).then(
      async (res) => {
        const result: any = await res.json();

        if (result && result.msg && (result.msg.indexOf('Nothing') > -1)) {
          presentAlert({
            header: 'Message',
            subHeader: '',
            message: 'Account not valid.',
            buttons: ['OK'],
          });
        } else if (result && result.msg && (result.msg.indexOf('already') > -1)) {
          // TODO: récup la pubkey côté server
          setPubkey(await userService?.getPubkey());
          presentAlert({
            header: 'Message',
            subHeader: '',
            message: `In-App Wallet already created. Your pubkey is: ${userService.pubkey}`,
            buttons: ['OK'],
          });
        } else if (result && result.pubkey && result.pubkey !== null) {

          setSeedkeyString(result.seedkey);
          setSeedkey(result.seedkey);
          setPubkey(result.pubkey);

          userService?.setSeedkey(result.seedkey);
          userService?.setPubkey(result.pubkey);

          // afficher la popin de seedkey
          setTimeout(() => {
            setShowAlertSeedKeyValue(true);
          }, 1000);

          // rafraichir le wallet
          setTimeout(() =>{
            refreshWallet();
          }, 2500);
        }
      })
      .catch((_e) => {
        presentAlert({
          header: 'Message',
          subHeader: '',
          message: `Please connect your device to Internet. If you are already connected, servers may be temporarily down or application need to be updated. ${_e}`,
          buttons: ['OK'],
        });
      });
  }

  /**
   * Modification du bouton de sauvegrade de Seed Key
   * @param value 
   */
  function setShowAlertSeedKeyValue(value: boolean) {
    setShowAlertSeedKey(value);
    if (value) {
      const interval = setInterval(() => {
        const seedKeyAlert = document.getElementById('seedKeyAlert');

        if (seedKeyAlert !== null && seedKeyAlert.children[2]) {
          clearInterval(interval);

          const childNode = seedKeyAlert.children[2];
          const childChildNode = childNode.children[2];
          const childButtonNode = childChildNode.children[0];

          childButtonNode.setAttribute('disabled', 'disabled');
          const childButtonText = childButtonNode.children[0];
          childButtonText.innerHTML = 'Please wait 10 seconds !';

          setTimeout(() => {
            childButtonNode.removeAttribute('disabled');
            childButtonText.innerHTML = 'Yes, i have saved my Seed Key';
          }, 10000);
        }

      }, 150);
    }
  }

  /**
   * Bouton validation de sauvegarde de Seed Key
   * @returns 
   */
  function getAlertButton() {
    return [
      {
        text: 'Yes, i have saved my Seed Key',
        handler: () => {
          console.log('Seed key alert done');
        }
      }
    ];
  }

  /**
   * Affichage du messge de confirmation de création du wallet
   * @returns 
   */
  function getAlertMessage() {
    // const seedkeyObject = seedkeyString.split(' ');
    return 'In-App Wallet created with success on Solana blockchain ! Please backup your wallet seed key, write it down, THIS KEY IS SAVED TO YOUR APP DATA BUT CANNOT BE RECOVERED SO WRITE IT AND KEEP IT IN SAFE PLACE, NEVER TRANSMIT THIS DATA TO ANYBODY. Your Seed Key is: ' + seedkeyString;
  }

  /**
   * Calcul du montanr "pre-sale" suivant le bouton choisi
   * @param amount 
   */
  function getAmount(amount: String) {
    // TODO: à fusionner avec laméthode en dessous
    let total = Number(walletBalanceSOL);

    switch (amount) {
      case 'max':
        setAmount(total.toString());
        break;
        
      case 'half':
        const half: string = (Math.round(((total / 2) + Number.EPSILON) * 100) / 100).toString();
        setAmount(half);
        break;
        
      case 'quarter':
        const quarter: string = (Math.round(((total / 4) + Number.EPSILON) * 100) / 100).toString();
        setAmount(quarter);
        break;
    
      default:
        setAmount('0.00');
        break;
    }
  }

  /**
   * Calcul du montant "send" suivant le bouton choisi
   * Max
   * Half
   * Quarter
   * @param amount 
   */
  function getTransactionAmount(amount: String, isInApp: boolean = false) {
    let total: number;

    if (isInApp) {
      const deviseInApp: WalletContent = inAppWalletContent.find((d) => inAppCurrency === d.symbol.toLowerCase());
      total = Number(deviseInApp.value);

    } else if (transferToInAppChecked) {
      total = Number(walletBalanceNSA);
    } else {
      switch(isDevise) {
        case Config.tokenNsaAddress:
          total = Number(walletBalanceNSA);
          break;
        
        case Config.tokenNsanAddress:
          total = Number(walletBalanceNSAN);
          break;
  
        default:
          const devise: WalletContent = walletContent.find((d) => (isDevise === d.mint));
          total = Number(devise.value);
          break;
      }
    }

    switch (amount) {
      case 'max':
        setTransactionAmount(total.toString());
        break;
        
      case 'half':
        const half: string = (Math.round(((total / 2) + Number.EPSILON) * 100) / 100).toString();
        setTransactionAmount(half);
        break;
        
      case 'quarter':
        const quarter: string = (Math.round(((total / 4) + Number.EPSILON) * 100) / 100).toString();
        setTransactionAmount(quarter);
        break;
    
      default:
        setTransactionAmount('0.00');
        break;
    }
  }

  /**
   * Méthode pour acheter des NSA en pre-sale
   */
  async function buyTokens() {

    await walletService.getTokenInfoPyth(solMint, userService).then(async res => {

      const response = await res.json();
      const solValues = response.usdPrice;
      const solLimit = solValues['solLimit'];
      const solUsd = solValues['solUsd'];
      const amountToSend = Number(amount);

      await totalPresale();
  
      if (amountToSend > Number(walletBalanceSOL)) {
        presentAlert({
          header: 'Message',
          subHeader: '',
          message: `You need a minimum of ${amount}  SOL in your wallet`,
          buttons: ['OK'],
        });
      } else if (amount === '0') {
        presentAlert({
          header: 'Message',
          subHeader: '',
          message: 'You need more than 0 SOL to get NSA tokens',
          buttons: ['OK'],
        });
      } else {
        if (amountToSend >= solLimit) {
          const seedBip39 = bip39.mnemonicToSeedSync(seedkey, ""); // (mnemonic, password)
          const keypair = Keypair.fromSeed(new Uint8Array(seedBip39.slice(0, 32)));
  
          const fee = (await (await walletService.calculateFeeTransfer(userService)).json()).fee;
          
          const priceWithReduction = startPrice - (startPrice * Number(reduction) / 100);
          const solAmountInUsd = (amountToSend - fee) * solUsd;
    
          const totalBought = solAmountInUsd / priceWithReduction;
    
          presentAlert({
            header: 'Message',
            subHeader: '',
            message: `Current Solana USD price is: $ ${solUsd}`,
            buttons: ['OK'],
          });
  
          presentAlert({
            header: 'Message',
            subHeader: '',
            message: `Your Solana amount represent $ ${solAmountInUsd}`,
            buttons: ['OK'],
          });
  
          presentAlert({
            header: 'Message',
            subHeader: '',
            message: `Current NSA price with discount of ${reduction}% is: $ ${priceWithReduction}`,
            buttons: ['OK'],
          });
    
          alert('You want to send ' + amountToSend + ' SOL with ' + fee + ' SOL fees, to get NSA tokens with a reduction of ' + reduction
                + '% with the account ' + userService.email + ' with publicKey ' + userService.pubkey + '. This represent a total of ' + totalBought + ' NSA');
  
          await transferSolOrSpltokenOrBuyPreSale(keypair, Accounts.sol, fee, amountToSend, totalBought, Number(reduction), true);
  
        } else {
          presentAlert({
            header: 'Message',
            subHeader: '',
            message: `Minimum amount to get NSA tokens is: ${solLimit} SOL`,
            buttons: ['OK'],
          });
        }
      }
    });
  }

  /**
   * Méthode "send" pour transférer des fonds Sol
   */
  async function startTransaction() {

    if (transferToInAppChecked) {
      // TODO: Transfert vers l'in-app wallet

      const functionEnabled = false;

      presentAlert({
        header: 'Message',
        subHeader: '',
        message: 'Sending NSA to your In-App wallet is currently not possible.',
        buttons: ['OK'],
      });

      // Transfer to in-app wallet
      const url = baseUrl + 'sendto-inapp-wallet?email=' + userService.email + '&security=' + userService.security + '&v=' + Config.version;

      if (functionEnabled) {
        fetch(url, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(
            {
              'amount': transactionAmount,
            }
          ), 
          signal: AbortSignal.timeout(5000) 
        }).then(
          async (res) => {
            await res.json();
  
            presentAlert({
              header: 'Message',
              subHeader: '',
              message: 'Send to your In-App wallet. It can take few minutes to update.',
              buttons: ['OK'],
            });
          }
        ).catch(() => {
          setShowAlertConnexion(true);
        });
      }
    } else {
      // Formulaire d'envoie de tokens
      if (showSendForm) {

        const amountToSend = Number(transactionAmount);

        // Si le destinataire est renseigné
        if (transactionAddress) {
          if (priorityFee <= Number(walletBalanceSOL)) {
            // todo: check si montant supérieur à total de la devise
            const selectedDevise = walletContent.find((d) => d.mint === isDevise);
            if (amountToSend <= Number(selectedDevise.value)) {

              // const destination = new PublicKey(transactionAddress);
              const seedBip39 = bip39.mnemonicToSeedSync(seedkey, ""); // (mnemonic, password)
              const keypair = Keypair.fromSeed(new Uint8Array(seedBip39.slice(0, 32)));

              // Création transaction d'envoie des tokens
              await transferSolOrSpltokenOrBuyPreSale(keypair, transactionAddress, 0, amountToSend, 0, 0, false, false, selectedDevise.mint);

            } else {
              alert(`Not enought ${selectedDevise.name} in the wallet`);
            }
          } else {
            alert('Not enought SOL in wallet to cover priority fee');
          }
        } else {
          alert('Please enter a destination address');
        }
      } else {

        await walletService.getTokenInfoPyth(solMint, userService).then(async res => {

          const response = await res.json();
          const solUsd: number = response.usdPrice;
          const amountToSend = Number(transactionAmount);
      
          await totalPresale();
      
          if (amountToSend > Number(walletBalanceSOL)) {
            presentAlert({
              header: 'Message',
              subHeader: '',
              message: `You need to have ${amount} SOL in your wallet`,
              buttons: ['OK'],
            });
          } else if (transactionAmount === '0') {
            presentAlert({
              header: 'Message',
              subHeader: '',
              message: 'You need to send more than 0 SOL',
              buttons: ['OK'],
            });
          } else {
            if (transactionAddress && transactionAddress.length > 0) {
              // const receiver = new PublicKey(transactionAddress);
              const seedBip39 = bip39.mnemonicToSeedSync(seedkey, ""); // (mnemonic, password)
              const keypair = Keypair.fromSeed(new Uint8Array(seedBip39.slice(0, 32)));
      
              const fee = (await (await walletService.calculateFeeTransfer(userService)).json()).fee;
              
              const priceWithReduction = startPrice - (startPrice * Number(reduction) / 100);
              const solAmountInUsd = (amountToSend - fee) * solUsd;
        
              const totalBought = solAmountInUsd / priceWithReduction;
        
              presentAlert({
                header: 'Message',
                subHeader: '',
                message: `You want to send ${amountToSend} SOL with fee of ${fee} SOL to ${transactionAddress} with the account ${userService.email} with publicKey ${userService.pubkey} .`,
                buttons: ['OK'],
              });
        
              await transferSolOrSpltokenOrBuyPreSale(keypair, transactionAddress, fee, amountToSend, totalBought, Number(reduction), false);

            } else {
              presentAlert({
                header: 'Message',
                subHeader: '',
                message: 'Please enter a destination address.',
                buttons: ['OK'],
              });
            }
          }
        });
      }
    }
  }

  /**
   * Create NSA asset dans le wallet
   */
  async function createSplTokenaccount(splToken: string) {
    
    const fee = (await (await walletService.calculateFeeTransfer(userService)).json()).fee;

    presentAlert({
      header: 'Message',
      subHeader: '',
      message: `This feature create a NSA asset in your wallet. To create this asset you need some SOL for the transaction fee and for the rent. The current fee is: ${fee + 0.002}. If you get any error please contact support on Telegram channel.`,
      buttons: ['OK'],
    });

    let isAccountNeeded = false;

    switch (splToken) {
      case Config.tokenNsaAddress:
        isAccountNeeded = needNSAaccount;
        break;

      case Config.tokenNsanAddress:
        isAccountNeeded = needNSANaccount;
        break;
    
      default:
        isAccountNeeded = false;
        break;
    }
    
    if (isAccountNeeded && Number(walletBalanceSOL) > 0.003) {

      setIsLoadingWallet(true);

      await walletService.createTokenAsset(splToken, seedkey, fee, userService).then(async signature => {
        
        setIsLoadingWallet(false);

        presentAlert({
          header: 'Message',
          subHeader: '',
          message: 'NSA asset created in your wallet. Wait 5s and refresh your wallet. Don\'t press the button a second time.',
          buttons: ['OK'],
        });
        
        setNeedNSAaccount(false);
        setTimeout(() =>{
          refreshWallet();
        }, 5000);
      });

      setIsLoadingWallet(false);
    } else if (needNSAaccount && Number(walletBalanceSOL) < 0.003) {
      presentAlert({
        header: 'Message',
        subHeader: '',
        message: 'You need around of 0.003 SOL in your wallet to pay transaction fee and ATA rent',
        buttons: ['OK'],
      });
    } else {
      presentAlert({
        header: 'Message',
        subHeader: '',
        message: 'NSA asset already available in your wallet',
        buttons: ['OK'],
      });
    }
  }

  /**
   * Transfert de SOL ou Transfert pour presale
   * @param keypair 
   * @param to 
   * @param fee 
   * @param amount 
   * @param totalBought 
   * @param reduction 
   * @param isPreSale 
   * @param isPlatform
   */
  async function transferSolOrSpltokenOrBuyPreSale(keypair: Keypair, destination: string, fee: number, amount: number, totalBought: number, reduction: number, isPreSale: boolean = true, isPlatform: boolean = false, addressSplToken?: string) {

    setSendTransactionBtnDisabled(true);

    if (keypair && destination && fee !== undefined && amount) {

      setIsLoadingWallet(true);

      // Transférer spl-token
      if (addressSplToken !== 'So11111111111111111111111111111111111111112') {

        await walletService.transferSplToken(addressSplToken, amount, destination, seedkey, fee, userService).then(async sign => {
          const response = await sign.json();
          setIsLoadingWallet(false);

          if (response.signature) {
            presentAlert({
              header: 'Message',
              subHeader: '',
              message: 'Transaction send. Your wallet will refresh in 10 seconds.',
              buttons: [
                {
                  text: 'Open',
                  role: 'open',
                  handler: () => {
                    gotoSolanaExplorer(response.signature);
                  },
                },
                {
                  text: 'Quit',
                  role: 'quit',
                  handler: () => {},
                } 
              ],
            }).finally(() => {
              setShowBuyForm(false);
              setShowDepositForm(false);
              setInAppShowSendForm(false);
              setShowSendForm(false);
            });
          }
        }).catch(() => {
          presentAlert({
            header: 'Message',
            subHeader: '',
            message: 'Transaction error, please contact support.',
            buttons: ['OK'],
          });
        }).finally(() => {
          setIsLoadingWallet(false);
          setSendTransactionBtnDisabled(false);
          setTimeout(() => {
            refreshWallet();
          }, 10000)
        });

      } else {
        // transaction sol

        await walletService.transferSolToken(addressSplToken, amount, destination, seedkey, fee, userService).then(async sign => {
          const response = await sign.json();
          setIsLoadingWallet(false);
          
          if (isPreSale) {
            if (response.signature) {
              presentAlert({
                header: 'Message',
                subHeader: '',
                message: 'Transaction send.',
                buttons: ['OK'],
              });
              window.open('https://explorer.solana.com/tx/' + response.signature + '?cluster=mainnet');
              presentAlert({
                header: 'Message',
                subHeader: '',
                message: 'Your transaction has been saved to the server queue. You will receive your NSA in 24/48h. The tokens are not transferred automatically, the procedure is manual and takes some time, thank you for your comprehension. For any problem please contact support on Telegram.',
                buttons: ['OK'],
              });
        
              const baseUrl = (Config.debugMode === false) ? Config.url : Config.urlDebug;
              const url = baseUrl + 'buytoken?email=' + userService.email + '&security=' + userService.security + '&signature=' + response.signature + '&totalbought=' + totalBought + '&reduction=' + reduction + '&v=' + Config.version;
        
              fetch(url, { signal: AbortSignal.timeout(5000) }).then(async (res) => {
                const result: any = await res.json();
        
                if (result && result.msg && (result.msg.indexOf('Invalid') > -1)) {
                  presentAlert({
                    header: 'Message',
                    subHeader: '',
                    message: 'Account not valid.',
                    buttons: ['OK'],
                  });
                } else if (result && result.msg && (result.msg.indexOf('activation') > -1)) {
                  presentAlert({
                    header: 'Message',
                    subHeader: '',
                    message: `Your transaction data are saved to the server queue. Your transaction signature is "${response.signature}", email: ${email} for a total of ${totalBought} NSA.`,
                    buttons: ['OK'],
                  });
                }
              })
              .catch((_e) => {
                presentAlert({
                  header: 'Message',
                  subHeader: '',
                  message: `Please connect your device to Internet. If you are already connected, servers may be temporarily down or application need to be updated. ${_e}`,
                  buttons: ['OK'],
                });
              })
              .finally(() => {
              });
        
            } else {
              presentAlert({
                header: 'Message',
                subHeader: '',
                message: 'Transaction error.',
                buttons: [
                  {
                    text: 'Open',
                    role: 'open',
                    handler: () => {
                      gotoSolanaExplorer(response.signature);
                    },
                  },
                  {
                    text: 'Quit',
                    role: 'quit',
                    handler: () => {},
                  } 
                ],
              }).finally(() => {
                setShowBuyForm(false);
                setShowDepositForm(false);
                setInAppShowSendForm(false);
                setShowSendForm(false);
              });
            }
          } else {
            if (response.signature) {
              presentAlert({
                header: 'Message',
                subHeader: '',
                message: 'Transaction was send. Your wallet will refresh in 10 seconds.',
                buttons: [
                  {
                    text: 'Open',
                    role: 'open',
                    handler: () => {
                      gotoSolanaExplorer(response.signature);
                    },
                  },
                  {
                    text: 'Quit',
                    role: 'quit',
                    handler: () => {},
                  } 
                ],
              }).finally(() => {
                setShowBuyForm(false);
                setShowDepositForm(false);
                setInAppShowSendForm(false);
                setShowSendForm(false);
              });
            }
          }
        }).catch(() => {
          presentAlert({
            header: 'Message',
            subHeader: '',
            message: 'Transaction error, please contact support.',
            buttons: ['OK'],
          });
        }).finally(() => {
          setIsLoadingWallet(false);
          setSendTransactionBtnDisabled(false);
          setTimeout(() => {
            refreshWallet();
          }, 10000)
        });
      }
    } else {
      setIsLoadingWallet(false);
      setSendTransactionBtnDisabled(false);
      if (!destination) {
        presentAlert({
          header: 'Message',
          subHeader: '',
          message: 'Please enter a destination address.',
          buttons: ['OK'],
        });
      } else if (!amount) {
        presentAlert({
          header: 'Message',
          subHeader: '',
          message: 'Please enter an amount.',
          buttons: ['OK'],
        });
      }
    }
  }

  function gotoSolanaExplorer(signature) {
    window.open('https://explorer.solana.com/tx/' + signature + '?cluster=mainnet');
  }

  /**
   * Calcul du total pre-sale pour afficher les données
   */
  async function totalPresale() {

    return walletService.getTokenInfoPyth(solMint, userService).then(async res => {
      const response = await res.json();

      const solUsd: number = response.usdPrice;
      const limit = 25; // Limite minimum 25$
      let solLimit: number = limit / solUsd;
        
      setSolLimit(solLimit);
      setIsLoadingWallet(false);
    });
  }

  /**
   * Mise à jour des données affichées pour le pre-sale
   */
  async function updatePresaleData() {
    setIsLoadingWallet(true);
    await totalPresale();
  }

  /**
   * Mise à jour des données du portefeuille
  */
  async function refreshWallet() {
    let fetching: string[] = []
    let totalDevises = 0;
    setWalletContent([]);
    let walletContentCopy: WalletContent[] = [];

    if (userService?.pubkey !== null) {

      setShowLoadingDots(true);

      // Get SOL balance
      getSolanaBalance().then(async (solToken) => {

        // Récupération token SOL
        if (solToken) {
          walletContentCopy.push(solToken);
        }

        if (userService?.pubkey !== null) {
    
          await walletService.getOurTokenAccountsByOwner(userService).then(async (response) => {
            const tokenAccounts: any = await response.json();
            const tokens: {pubkey:PublicKey;account:AccountInfo<ParsedAccountData>;}[] = tokenAccounts?.result?.value;
            tokens.forEach(async token => {
    
              const parsedToken: ParsedAccount = token?.account?.data?.parsed;
              const tokenAmount = parsedToken.info.tokenAmount;

              if (tokenAmountIsNotNFT(tokenAmount) && parsedToken) {
                const mintAddress:string = parsedToken?.info?.mint;
                const tokenBalance: number = parsedToken?.info?.tokenAmount?.uiAmount;
    
                fetching.push('loading');
                let itemParsed: WalletContent = null;
    
                if (isNSA(mintAddress) || isNSAN(mintAddress)) {
        
                  itemParsed = {
                    name: isNSA(mintAddress) ? 'Nebula Stars Anthill' : 'Nebula Stars Anthill Nucleus',
                    symbol: isNSA(mintAddress) ? 'NSA' : 'NSAN',
                    mint: mintAddress,
                    value: tokenBalance.toString(),
                    price: isNSA(mintAddress) ? '0.015727272' : '78.63636',
                    price_last: isNSA(mintAddress) ? '0.015727272' : '78.63636',
                    link: `https://explorer.solana.com/address/${mintAddress}?cluster=mainnet`,
                    img: isNSA(mintAddress) ? getDeviseIcon('NSA') : getDeviseIcon('NSAN'),
                    parsed: true,
                  };

                  if (isNSA(mintAddress)) {
                    setWalletBalanceNSA(tokenBalance.toString());
                    setNeedNSAaccount(false);
                  } else {
                    setWalletBalanceNSAN(tokenBalance.toString());
                    setNeedNSANaccount(false);
                  }
                } else {
    
                  await walletService.getTokenInfoPyth(mintAddress, userService).then(async res => {
                    const result = await res.json()
    
                    itemParsed = {
                      name: result['name'],
                      symbol: result['symbol'],
                      mint: mintAddress,
                      value: tokenBalance.toString(),
                      price: result['usdPrice'],
                      price_last: result['usdPrice'],
                      link: `https://explorer.solana.com/address/${mintAddress}?cluster=mainnet`,
                      img: result['icon'],
                      parsed: true,
                    };
                  }).catch(() => {
                    // cannot catch item
                  });
                }
    
                setWalletContent(walletContent => [...walletContent, itemParsed]);
                // Recupération token Token
                walletContentCopy.push(itemParsed);
                totalDevises = totalDevises + Number(getTotalValue(itemParsed.price, itemParsed.value));
    
                fetching.pop();
              }
            });
          }).catch((_e: any) => {
            setIsLoadingWallet(false);
            const formatError = _e.toString().indexOf('NetworkError') > -1
              ? 'Impossible to access network, please check your internet access and restart the app or click on refresh button.' 
              : (!userService?.pubkey) ? 'Wallet not found, please click on CREATE button.' : 'Unable to access server'; //_e;
            presentAlert({
              header: 'Message',
              subHeader: '',
              message: 'Error ' + formatError,
              buttons: ['OK'],
            });
          }).finally(() => {
            setIsLoadingWallet(false);
            setShowLoadingDots(false);
            setTotal(Number(totalDevises?.toFixed(3)));
            
            userService.setWalletContentData(walletContentCopy);
            userService.setWalletContentCalled();
          });
        }
      });

      // Wallet In-App récupération des devises
      getInAppAccounts();
    } else {
      presentAlert({
        header: 'Message',
        subHeader: '',
        message: 'Wallet not found.\nPress the CREATE button to create one and write your seedKey.',
        buttons: ['OK'],
      });
    }
  }

  function isNSA(mintAddress) {
    return isToken(mintAddress, Config.tokenNsaAddress);
  }

  function isNSAN(mintAddress) {
    return isToken(mintAddress, Config.tokenNsanAddress);
  }

  function isToken(mintAddress, compareAddress) {
    return mintAddress === compareAddress;
  }

  function tokenAmountIsNotNFT(tokenAmount: TokenAmount) {
    return tokenAmount?.decimals !== 0 && tokenAmount?.amount !== '1';
  }

  function manualRefreshWallet() {

    const refreshButton = document.getElementById('refresh-button');
    const refreshButtonIsDisabled = refreshButton.attributes.getNamedItem('disabled');
    const refreshButtonDefaultInner = refreshButton.innerHTML;

    if (!refreshButtonIsDisabled || refreshButtonIsDisabled?.nodeValue === 'false') {
      refreshButton.setAttribute('disabled', 'true');
      setRefreshing(true);
      refreshWallet();
    }

    // Décompte du temps de disabled
    let temps = 10;
    const timer = setInterval(() => {
      if (temps === 0) {
        refreshButton.innerHTML = refreshButtonDefaultInner;
        refreshButton.setAttribute('disabled', 'false');
        setRefreshing(false);
        clearInterval(timer);
      } else {
        refreshButton.innerHTML = temps.toString();
        temps--;
      }
    }, 1000);
  }

  function showHideWallet(isInAppWallet: boolean) {
    if (isInAppWallet) {
      document.getElementById('in-app-wallet').style.display = 'block';
      document.getElementById('solana-mainnet-wallet').style.display = 'none';
    } else {
      document.getElementById('solana-mainnet-wallet').style.display = 'block';
      document.getElementById('in-app-wallet').style.display = 'none';
    }
    setShowInAppWallet(isInAppWallet);
  }

  function changeInAppCurrency(currency: any) {
    setInAppCurrency(currency);
  }

  function getDeviseIcon(devise: string) {
    const lowerCaseDevise = devise ? devise.toLocaleLowerCase() : 'nsa';
    const assetPath = '/assets/wallet';
    const suffix = 'logo.png';
    const finalUrl = `${assetPath}/${lowerCaseDevise}_${suffix}`;

    if (devise) {
      return finalUrl;
    } else {
      return `${assetPath}/unknown_${suffix}`;
    }
  }

  function getCoinGeckoDeviseIcon(devise: string) {
    return (devise)
      ? devise
      : '/assets/wallet/unknown_logo.png';
  }

  function getReadableValue(value: string, toFixed: number = 3) {
    return Number(value) % 1 ? Number(value)?.toFixed(toFixed) : value;
  }

  function getTotalValue(price: string, value: string) {
    return ((price ? Number(price) : 0) * (value ? Number(value) : 0)).toString();
  }

  function isDeviseAllowed(item, invert) {
    if (item.mint === Config.tokenNsaAddress || item.mint === Config.tokenNsanAddress) {
      return invert ? false : true;
    } else {
      return invert ? true : false;
    }
  }

  return (
    <IonPage>
      <IonContent fullscreen className="container-wallet-content">

        { !isRefreshing &&
          <IonRefresher slot="fixed" closeDuration={'1000ms'} pullFactor={0.5} pullMin={200} pullMax={500} onIonRefresh={manualRefreshWallet}>
            <IonRefresherContent></IonRefresherContent>
          </IonRefresher>
        }

        { showUpdateDownload &&
          <div style={{zIndex: 9999, position: 'fixed', marginTop: '150px', marginLeft: 'calc(50% - 232.3px / 2)', background: 'black', display: 'flex', flexDirection: 'column', borderRadius: '15px', padding: '15px'}}>
            <h1 style={{marginTop: 0}}>Info</h1>
            <p style={{marginTop: '.5rem', marginBottom: 0, fontSize: '16px'}}>An update is available.</p>
            <p style={{marginTop: '.5rem', marginBottom: 0, fontSize: '16px'}}>Your current version is: {updateService.versionInstalled}</p>
            <p style={{marginTop: '.5rem', marginBottom: 0, fontSize: '16px'}}>The latest version is: {updateService.versionServer}</p>
            <p style={{marginTop: '.5rem', marginBottom: 0, fontSize: '16px'}}><b>Proceed to the update ?</b></p>
            <div style={{textAlign: 'right', paddingTop: '.7rem'}}>
              <button style={{width: '50px', padding: '7px 10px', borderRadius: '5px'}} onClick={() => setShowUpdateDownload(false)}>No</button>
              <button style={{width: '50px', padding: '7px 10px', borderRadius: '5px', marginLeft: '5px', background: 'rgb(133,231,133)', color: 'black'}} onClick={() => {setShowDownload(true); updateService.updateApplication(userService)}}>Yes</button>
            </div>
          </div>
        }
        <IonLoading message="Downloading update please wait... ~15mb" isOpen={showDownload}></IonLoading>

        {/* Barre d'entête */}
        <IonGrid className="wallet-bar">
          <IonRow>
            <IonCol size="2">
              <IonImg className="wallet-bar-img" src="/assets/icon/new_icon.png" />
            </IonCol>
            <IonCol size="8">
              <IonRow style={{ height: '60px'}}>
                <IonCol size="6" style={{ paddingTop: '0', paddingBottom: '0' }}>
                  <IonButton id="open-my-in-app-wallet" className={showInAppWallet ? 'active': 'inactive'} color="primary" style={{ height: '52px', width: '100%' }} onClick={
                    () => showHideWallet(true)
                  }>In-App <IonIcon icon={walletOutline} slot="end"></IonIcon></IonButton>
                </IonCol>
                <IonCol size="6" style={{ paddingTop: '0', paddingBottom: '0' }}>
                  <IonButton id="open-my-mainnet-wallet" className={!showInAppWallet ? 'active': 'inactive'} color="primary" style={{ height: '52px', width: '100%' }} onClick={
                    () => showHideWallet(false)
                  }>Main <IonIcon icon={walletSharp} slot="end"></IonIcon></IonButton>
                </IonCol>
              </IonRow>
            </IonCol>
          </IonRow>
        </IonGrid>

        <div className="container-wallet">

          <div id="solana-mainnet-wallet" className="container-wallet-common">

            <IonAlert
              id="seedKeyAlert"
              isOpen={showAlertSeedKey}
              header={'Wallet'}
              subHeader={'Backup your Seed Key'}
              message={getAlertMessage()}
              buttons={getAlertButton()}
              backdropDismiss={false}
            />

            <div className="common-buttons">
              <IonCard className={showSendForm ? "active" : ""} onClick={() => showSend()}>
                <IonIcon color="primary" className="icon-icon-list" icon={arrowUpCircle} />
                <IonCardHeader>
                  <IonCardSubtitle>Transfer</IonCardSubtitle>
                </IonCardHeader>
              </IonCard>

              <IonCard className={showDepositForm ? "active" : ""} onClick={() => showDeposit()}>
                <IonIcon color="primary" className="icon-icon-list" icon={arrowDownCircle} />
                <IonCardHeader>
                  <IonCardSubtitle>Deposit</IonCardSubtitle>
                </IonCardHeader>
              </IonCard>

              { (userService.email && userService.email.indexOf('ogle.bot') === -1) &&
                <IonCard className={showBuyForm ? "active" : ""} onClick={() => showBuy()}>
                  <IonIcon color="primary" className="icon-icon-list" icon={add} />
                  <IonCardHeader>
                    <IonCardSubtitle><b>BUY</b></IonCardSubtitle>
                  </IonCardHeader>
                </IonCard>
              }

              <IonCard disabled={userService.pubkey && userService.pubkey.length > 10} onClick={() => createWallet(email, security)}>
                <IonIcon color="primary" className="icon-icon-list" icon={wallet} />
                <IonCardHeader>
                  <IonCardSubtitle>Create</IonCardSubtitle>
                </IonCardHeader>
              </IonCard>

              <IonCard onClick={() => exploreAddress()}>
                <IonIcon color="primary" className="icon-icon-list" icon={timeOutline} />
                <IonCardHeader>
                  <IonCardSubtitle>Histo.</IonCardSubtitle>
                </IonCardHeader>
              </IonCard>

            </div>

            {/* Bouton create NSA account */}
            { needNSAaccount && userService.pubkey &&
                <div className="compteur-adresse">
                  <IonButton color="secondary" onClick={() => createSplTokenaccount(Config.tokenNsaAddress)}>Create NSA ATA (Associated Token Account)</IonButton>
                </div>
            }

            {/* Bouton create NSAN account */}
            { needNSANaccount && userService.pubkey &&
                <div className="compteur-adresse color-black">
                  <IonButton color="primary" onClick={() => createSplTokenaccount(Config.tokenNsanAddress)}>Create NSAN ATA (Associated Token Account)</IonButton>
                </div>
            }

            { showSendForm &&
              <div className='send'>

                <IonItem>
                  <IonCheckbox slot="start" onIonChange={e => setTransferToInAppChecked(e.detail.checked)}></IonCheckbox>
                  <IonLabel>Transfer NSA to In-App wallet</IonLabel>
                </IonItem>

                { !transferToInAppChecked &&
                  <div>
                    <IonItem>
                      <IonSelect placeholder="Select devise" onIonChange={e => setDevise(e.detail.value)}>
                        {walletContent.map((item, i) => (
                          // On filtre les devises autorisées
                          isDeviseAllowed(item, true) &&
                            <IonSelectOption disabled={isDeviseAllowed(item, false)} key={'devise_'+i} value={item.mint}>
                              <IonImg src={item.img}></IonImg> {item.name}
                            </IonSelectOption>
                        ))}
                      </IonSelect>
                    </IonItem>
                    <IonItem>
                      <IonLabel>Address:</IonLabel>
                      <IonInput placeholder="Receiver address..." value={transactionAddress}  onIonChange={e => setTransactionAddress(e.detail.value!)} type={'text'}></IonInput>
                      <IonButton onClick={() => setOpenQrScan(true)}><IonIcon icon={camera}></IonIcon></IonButton>
                    </IonItem>
                    {/* <IonItem>
                      <IonLabel position="floating">Compute Units:</IonLabel>
                      <IonInput disabled={true} placeholder="96000" inputmode={'numeric'} value={computeUnits} onIonChange={e => setComputeUnits(Number(e.detail.value!))} type={'text'}></IonInput>
                    </IonItem>
                    <IonItem>
                      <IonLabel position="floating">Priority fee (SOL):</IonLabel>
                      <IonInput disabled={true} placeholder="0.000025" inputmode={'numeric'} value={priorityFee} onIonChange={e => calcPriorityFee(Number(e.detail.value!))} type={'text'}></IonInput>
                    </IonItem> */}
                  </div>
                }

                <IonItem>
                  <IonLabel position="floating">Amount:</IonLabel>
                  <IonInput placeholder="Amount to send..." inputmode={'numeric'} value={transactionAmount} min={0} onIonChange={e => setTransactionAmount(e.detail.value!)} type="number"></IonInput>
                </IonItem>

                { isDevise &&
                  <>
                    <IonButton className="amount-button" color="secondary" onClick={() => getTransactionAmount('max')}>Maximum</IonButton>
                    <IonButton className="amount-button" color="secondary" onClick={() => getTransactionAmount('half')}>Half</IonButton>
                    <IonButton className="amount-button" color="secondary" onClick={() => getTransactionAmount('quarter')}>Quarter</IonButton>
                  </>
                }
                { isLoadingWallet &&
                  <IonSpinner name="dots" className="dots-spinner send-transaction"></IonSpinner>
                }
                <IonButton className="transaction sendBtn" color="secondary" disabled={sendTransactionBtnDisabled || !isDevise || (!priorityFee || priorityFee === 0)} onClick={() => startTransaction()}><IonIcon icon={wallet} style={{marginRight: '5px'}} /> Send transaction</IonButton>
              </div>
            }

            { isOpenQRScan &&
            
              <div className="qrscanner-modal">
                <IonHeader style={{display: 'flex'}}>
                  <IonToolbar>
                    <IonTitle>QRCode scanner</IonTitle>
                    <IonButtons slot="end">
                      <IonButton onClick={() => setOpenQrScan(false)}>Close</IonButton>
                    </IonButtons>
                  </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                  <QrReader
                    className="qr-reader"
                    delay={100}
                    style={{
                      height: 240,
                      width: 320,
                    }}
                    onError={(error) => console.error(error)}
                    onScan={(data) => handleScan(data)}
                    />
                </IonContent>
              </div>
            }

            { showDepositForm &&
              <div className="deposit">
                <p className="title">Your address:</p>
                <p className="pubkey-hash">{userService.pubkey} <CopyToClipboard text={userService.pubkey}>
                  <IonIcon className="icon-icon-list" icon={copy} onClick={
                    () => { presentAlert({
                      header: 'Message',
                      subHeader: '',
                      message: `Your address "${userService.pubkey}" has been copied to clipboard`,
                      buttons: ['OK'],
                    }) }
                    } /></CopyToClipboard>
                </p>
                <div className="qrcode-background">
                  <QRCode
                    className="qrcode"
                    value={userService.pubkey}
                  />
                </div>
              </div>
            }

            { showBuyForm &&
              <div className='buy'>

                <IonButton className="transaction" color="secondary" onClick={() => updatePresaleData()}>Update service data</IonButton>
                <p className="sub-label-title first">Service status is: <u>{preSaleStatus}</u>.</p>
                <p className="sub-label-title middle">Presale status is: <u>Public</u>.</p>
                {/* <p className="sub-label-title middle">Remaining: <b>{remainingJoinDays}</b> days.</p> */}
                <p className="sub-label-title middle">Min. SOL to buy NSA:<br/><b>SOL {minSolToBuy.toFixed(4)}</b></p>
                <p className="sub-label-title middle">Current discount:<br/><b>{reduction}%</b></p>
                <p className="sub-label-title middle">Discount price for 1 NSA:<br/><b>USDT {(startPrice / 100 * (100 - Number(reduction))).toFixed(9)}</b></p>
                {/* <p className="sub-label-title middle">NSA remaining in pre-sale:<br/><b>{remaining}</b></p> */}
                {/* <p className="sub-label-title last">NSA currently distributed is:<br/><b>{totalNSASent}</b></p> */}
                {/* <p className="sub-label-title last">NSAN currently distributed is:<br/><b>{totalNSANSent}</b></p> */}
                
                <IonItem>
                  <IonLabel position="floating">SOL Amount:</IonLabel>
                  <IonInput type="number" placeholder="Enter the amount..." value={amount} onIonChange={e => setAmount(e.detail.value!)}></IonInput>
                </IonItem>

                <IonButton className="amount-button" color="secondary" onClick={() => getAmount('max')}>Maximum</IonButton>
                <IonButton className="amount-button" color="secondary" onClick={() => getAmount('half')}>Half</IonButton>
                <IonButton className="amount-button" color="secondary" onClick={() => getAmount('quarter')}>Quarter</IonButton>

                <IonButton className="transaction" color="secondary" onClick={() => buyTokens()}><IonIcon icon={wallet} style={{marginRight: '5px'}}/> Get tokens</IonButton>
              </div>
            }

            { userService.pubkey &&
              <div id="common-history" className="common-history">
                <div className="header-container">
                  <h1 className="title">
                    Total
                    <IonButton color="primary" className="position-icon-eye" onClick={() => hideValue()}>
                      <IonIcon icon={eye} />
                    </IonButton>
                    <IonButton color="primary" id="refresh-button" className="position-icon-refresh" onClick={() => manualRefreshWallet()}>
                      <IonIcon icon={refresh} />
                    </IonButton>
                    { showLoadingDots &&
                      <IonSpinner name="dots" className="dots-spinner"></IonSpinner>
                    }
                  </h1>
                  <h3 className="total">${total}</h3>
                </div>
                
                <IonList>

                  {walletContent.map((item, i) => (
                    <IonItem className="token-item" key={'history' + i} style={{'--inner-padding-end': 0}}>
                      <IonLabel style={{margin: 0}}>
                        <IonGrid style={{padding: 0}}>
                          <IonRow class="ion-justify-content-between">
                            <IonCol size="7" style={{display: 'flex', flexDirection: 'row'}}>
                              <IonImg src={getCoinGeckoDeviseIcon(item.img)} className="devise-icon devise-border"></IonImg>
                              <div className="devise-name">
                                <span className="tiny-link" onClick={() => { window.open(item.link); }}>{item.name ?? item.mint}</span>
                                <span className="devise-name-price">${item.price}</span>
                              </div>
                            </IonCol>
                            <IonCol size="5" class="devise-value align-right" style={{margin: 'auto 0x', fontSize: '1rem'}}>
                              <span className="devise-value-total">{getReadableValue(item.value)} {item.symbol}</span>
                              <span className="devise-value-price">${getReadableValue(getTotalValue(item.price, item.value))}</span>
                            </IonCol>
                          </IonRow>
                        </IonGrid>
                      </IonLabel>
                    </IonItem>
                  ))}

                </IonList>
              </div>
              }
          </div>

          <div id="in-app-wallet" className="container-wallet-common">

            { showAlertConnection &&
              <div className="no-connection wallet">
                <span>
                  <h1>Please check your internet connection.</h1>
                  <p>If your connection is working, it is likely that the servers are under maintenance.</p>
                  <p>Please visit the support channels for information.</p>
                  <h2>Your wallet remains usable during maintenance.</h2>
                  <IonButton color="secondary" style={{ height: "52px" }} onClick={() => showHideWallet(false)}><IonIcon icon={enter} style={{ paddingRight: "5px" }}></IonIcon> Wallet</IonButton>
                </span>
              </div>
            }

            <div className="common-buttons">
              <IonCard onClick={() => showInAppSend()}>
                <IonIcon color="primary" className="icon-icon-list" icon={arrowUpCircle} />
                <IonCardHeader>
                  <IonCardSubtitle>Transfer</IonCardSubtitle>
                </IonCardHeader>
              </IonCard>

              <IonCard disabled={true} onClick={() => alert('Stacking tokens is currently not available from the in-app wallet.')}>
                <IonIcon color="primary" className="icon-icon-list" icon={arrowDownCircle} />
                <IonCardHeader>
                  <IonCardSubtitle>Stack</IonCardSubtitle>
                </IonCardHeader>
              </IonCard>
            </div>

            {/* { needNSAaccount && userService.pubkey &&
                <div className="compteur-adresse">
                  <IonButton color="secondary" onClick={() => createSplTokenaccount(Config.tokenNsaAddress)}>Create NSA asset in the wallet</IonButton>
                </div>
            }

            { needNSANaccount && userService.pubkey &&
                <div className="compteur-adresse color-black">
                  <IonButton color="primary" onClick={() => createSplTokenaccount(Config.tokenNsanAddress)}>Create NSAN asset in the wallet</IonButton>
                </div>
            } */}

            { showInAppSendForm &&
              <div className='send'>

                <IonItem>
                  <IonSelect defaultValue="nsa" onIonChange={(e) => { changeInAppCurrency(e.detail.value) }}>
                    <IonSelectOption value="nsa">NSA</IonSelectOption>
                    <IonSelectOption value="nsan">NSAN</IonSelectOption>
                  </IonSelect>
                </IonItem>
                
                <IonItem>
                  <IonLabel position="floating">Enter Amount:</IonLabel>
                  <IonInput placeholder="Enter the amount..." value={transactionAmount}  onIonChange={e => setTransactionAmount(e.detail.value!)} type="number"></IonInput>
                </IonItem>

                <IonButton className="amount-button" color="secondary" onClick={() => getTransactionAmount('max', true)}>Maximum</IonButton>
                <IonButton className="amount-button" color="secondary" onClick={() => getTransactionAmount('half', true)}>Half</IonButton>
                <IonButton className="amount-button" color="secondary" onClick={() => getTransactionAmount('quarter', true)}>Quarter</IonButton>

                <IonButton className="transaction" color="secondary" disabled={true} onClick={() => startTransaction()}><IonIcon icon={wallet} style={{marginRight: '5px'}} /> Send transaction</IonButton>
              </div>
            }

            { userService.pubkey &&
              <div id="common-history" className="common-history">
                <div className="header-container">
                  <h1 className="title">
                    Wallet content
                    <IonButton color="primary" style={{left: '98px'}} className="position-icon-eye" onClick={() => alert('Hide in-app value')}>
                      <IonIcon icon={eye} />
                    </IonButton>
                    <IonButton color="primary" style={{left: '140px'}} id="refresh-button" className="position-icon-refresh" onClick={() => alert('Refresh in-app wallet')}>
                      <IonIcon icon={refresh} />
                    </IonButton>
                  </h1>
                  <h3 className="total">0</h3>
                </div>

                <IonList>

                  {inAppWalletContent.map((item, i) => (
                    <IonItem className="token-item" key={'history' + i} style={{'--inner-padding-end': 0}}>
                      <IonLabel style={{margin: 0}}>
                        <IonGrid style={{padding: 0}}>
                          <IonRow class="ion-justify-content-between">
                            <IonCol size="7" style={{display: 'flex', flexDirection: 'row'}}>
                              <IonImg src={getDeviseIcon(item.symbol)} className="devise-icon devise-border"></IonImg>
                              <div className="devise-name">
                                <span className="tiny-link" onClick={() => { window.open(item.link); }}>{item.name}</span>
                                <span className="devise-name-price">${item.price}</span>
                              </div>
                            </IonCol>
                            <IonCol size="5" class="devise-value align-right" style={{margin: 'auto 0x', fontSize: '1rem'}}>
                              <span className="devise-value-total">{getReadableValue(item.value)} {item.symbol === item.name ? '???' : item.symbol}</span>
                              <span className="devise-value-price">${getReadableValue(getTotalValue(item.price, item.value))}</span>
                            </IonCol>
                          </IonRow>
                        </IonGrid>
                      </IonLabel>
                    </IonItem>


                  ))}

                </IonList>
              </div>
              }

          </div>
        </div>

      </IonContent>
    </IonPage>
  );
};

export default Wallet;

export type WalletContent = {
  name: string;
  symbol: string;
  mint: string;
  value: string;
  price: string;
  price_last: string;
  link: string;
  img: string;
  parsed: boolean;
};